import React, { useEffect, useState } from "react";
import Products from "../Products";
import { useLanguage } from '../../components/hooks/LanguageContext'; // <-- используем хук

const AboutAnalyticSolution = ({ features }) => {
    const [animate, setAnimate] = useState(false);
    const { language } = useLanguage(); // используем глобальный язык

    useEffect(() => {
        const timer = setTimeout(() => setAnimate(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const textContent = {
        ru: {
            title: "Решения аналитики",
            description: "Наша платформа предлагает решения для поддержки стратегического планирования: анализ трафика, прогнозирование прибыльности, визуализацию данных и индивидуальные отчеты.",
            button: "Попробовать"
        },
        en: {
            title: "Analytics Solutions",
            description: "Our platform provides tools to support strategic business planning: footfall analysis, profitability forecasting, data visualisation, and custom reports.",
            button: "Try Now"
        }
    };
    const currentText = textContent[language];

    return (
        <section className="features13 cid-uHqHY3c7dV" id="features13-1f">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-6">
                        <div className={`card-wrapper ${animate ? "fade-in-up" : "hidden"}`}>
                            <div className="card-box align-left">
                                <h4 className="card-title mbr-fonts-style mb-4 display-2">
                                    <strong>{currentText.title}</strong>
                                </h4>
                                <p className="mbr-text mbr-fonts-style mb-4 display-7" style={{ whiteSpace: 'pre-line' }}>
                                    {currentText.description}
                                </p>
                                <div className="mbr-section-btn">
                                    <a className="btn btn-danger display-4" href={Products.link}>
                                        {currentText.button}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        {features.map((feature, index) => (
                            <div
                                className={`item features-without-image ${animate ? "fade-in-left" : "hidden"}`}
                                key={index}
                                style={{ animationDelay: `${index * 150}ms` }}
                            >
                                <div className="item-wrapper mbr-flex">
                                    <div className="icon-box">
                                        <span className={`mbr-iconfont ${feature.icon} mobi-mbri`}></span>
                                    </div>
                                    <div className="text-box">
                                        <h4 className="icon-title mbr-black mbr-fonts-style display-7">
                                            <strong>{feature.title}</strong>
                                        </h4>
                                        <h5 className="icon-text mbr-black mbr-fonts-style display-4">
                                            {feature.text}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutAnalyticSolution;
